<template>
  <div>
    <div class="alert alert-success mb-0" v-show="success">{{ success }}</div>
    <div class="alert alert-danger mb-0" v-show="error">{{ error }}</div>
    <div class="container-fluid mt-2">
      <div class="row">
        <div class="row">
          <form id="form" :action="api+'api/v1/update/sub-reseller/'+$route.params.id">
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.account }} </div>
                <div class="card-block">
                  <div class="form-group">
                    <label for="">{{ t.name }}</label>
                    <input type="text" name="name" v-model="user.fullName" class="form-control" maxlength="30" required="" value=""> </div>
                  <div class="form-group">
                    <label for="">{{ t.user.telephone }}</label>
                    <input type="text" name="phone" v-model="user.phoneS" class="form-control" maxlength="15" value=""> </div>
                  <div class="form-group">
                    <label for="">{{ t.details }}</label>
                    <textarea name="detail" class="form-control" v-model="user.note" rows="5"></textarea>
                  </div>
                </div>
              </div>
              <div class="card" v-if="user.hasOwnProperty('disabled_providers')">
                <div class="card-header"> Casino </div>
                <div class="card-block" :class="(providerToggle) ? 'opened' : 'closed'">
                  <div class="form-check mt-2" v-for="p in providers">
                    <label class="form-check-label">
                      <input @click="updateProvider(p.id)" type="checkbox" class="form-check-input" :checked="checkProvider(p.id)"/>
                      {{ p.name }}
                    </label>
                  </div>
                  <input type="hidden" name="disabled_provider" :value="disabledProviders.join(',')"/>
                </div>
                <a class="btn" @click="toggle()">{{ t.all }}</a>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="card">
                <div class="card-header"> {{ t.details}} </div>
                <div class="card-block">
                  <div class="form-group">
                    <label for="">{{ t.user.username }}</label>
                    <input type="text" name="username" v-model="user.username" class="form-control" maxlength="20" required="" value=""> </div>
                  <div class="form-group">
                    <label for="">{{ t.user.password }}</label>
                    <div class="input-group">
                      <input type="text" v-model="password" class="form-control" name="password" maxlength="20" value="">
                      <span class="input-group-btn">
                        <button class="btn btn-link" type="button" id="generatePassword" @click="generatePasswordFx">{{ t.custom_reseller_panel.generate_password }}</button>
                      </span>
                    </div>
                  </div>
                  <div class="form-check mt-2">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" name="active" checked=""> {{ t.custom_reseller_panel.is_active }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="card card-block">
                <button type="submit" class="btn btn-success" id="form-submit-button">{{ t.edit_and_save }}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminUpdate",
  data () {
    return {
      t: this.$root.t,
      api: window.api,
      error: null,
      success: null,
      password: null,
      user: {},
      providers: [],
      disabledProviders: [],
      providerToggle: false
    }
  },
  mounted() {
    this.submitForm()
    this.fetchCasinoProviders()
  },
  methods: {
    toggle() {
      this.providerToggle = (this.providerToggle) ? false : true
    },
    updateProvider(pid) {
      var i = this.disabledProviders.indexOf(pid);
      if( i !== -1) {
        this.disabledProviders.splice(i)
      }else {
        this.disabledProviders.push(pid)
      }
    },
    checkProvider(pid) {
      return (this.disabledProviders && this.disabledProviders.indexOf(pid) !== -1) ? false : true
    },
    fetchCasinoProviders() {
      this.$http.get(api + 'api/v1/casino/providers',
          {params: this.$route.query})
          .then(response => {
            this.providers = response.body.result;
            this.userDetail()
          }, response => {
      })
    },
    userDetail() {
      this.$http.get(api + 'api/v1/users?uid=' + this.$route.params.id)
          .then(response => {
            this.user = response.body.result.users[0];
            this.disabledProviders = this.user.disabled_providers.split(",").map(function(t){return parseInt(t)})
          }, response => {
          })
    },
    generatePasswordFx(){
      var number = this.generatePassword(10);
      this.password = number;
    },
    submitForm(){
      const form = document.querySelector("#form");
      form.addEventListener("submit", e => {
        e.preventDefault();
        const fd = new FormData(form);
        const xhr = new XMLHttpRequest();
        xhr.addEventListener("load", e => {

          if(e.currentTarget.status === 200){
            this.success = this.t.processing.success;

            setTimeout(() => {
              this.success = null;
            }, 5000)
          }


          if(e.currentTarget.status === 400){
            this.error = JSON.parse(e.target.responseText).error;

            setTimeout(() => {
              this.error = null;
            }, 5000)
          }

        });
        xhr.addEventListener("error", e => {
          console.log(e);
          this.error = JSON.parse(e.target.responseText).error;
        });
        xhr.open("POST", form.action);
         xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader('Accept-Language', session.locale.locale)
        xhr.setRequestHeader('Authorization', 'Bearer ' + window.auth.accessToken)
        xhr.send(this.urlencodeFormData(fd));
      });
    },
      urlencodeFormData(fd){
      var params = new URLSearchParams(fd);
      return params.toString();
    }
  }
}
</script>

<style scoped>
.closed {
  height: 190px;
  overflow: hidden;
}
.opened {
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/views/AdminUpdate.vue